import { Component, OnInit, Input } from '@angular/core';
import { IconButtonTypeEnum } from '../shared/models/enums/icon-button-type-enum';

@Component({
    selector: 'app-icon-button',
    templateUrl: './icon-button.component.html',
    styleUrls: ['./icon-button.component.scss'],
    standalone: false
})
export class IconButtonComponent implements OnInit {
  
  public iconType!: any;
  public iconTypeMap! : {[index: number]: {src: string, svgClass: string}};

  @Input() iconButtonType!: number;
  @Input() text!: string;
   
  constructor() {this.iconType = IconButtonTypeEnum }

  ngOnInit(): void {
    this.iconTypeMap = {
      [IconButtonTypeEnum.edit]: {src: '/assets/icons/edit.svg', svgClass: 'edit'},
      [IconButtonTypeEnum.delete]: {src: '/assets/icons/delete.svg', svgClass: 'delete'},
      [IconButtonTypeEnum.attachment]: {src: '/assets/icons/attachment.svg', svgClass: 'attachment'},
      [IconButtonTypeEnum.add]: {src: '/assets/icons/add.svg', svgClass: 'add'},
      [IconButtonTypeEnum.deleteRed]: {src: '/assets/icons/delete-red.svg', svgClass: 'delete-red'},
      [IconButtonTypeEnum.editNew]: {src: '/assets/icons/edit-blue.svg', svgClass: 'edit-new'}
    }
  }
}
